import React from 'react';

const AlertMessage = ({ message, type = "success", onClose }) => {
  return (
    <div className={`alert alert-${type} alert-dismissible fade show`} role="alert" style={{ position: 'fixed', top: '1rem', right: '1rem', zIndex: 9999 }}>
      {message}
      <button type="button" className="btn-close" onClick={onClose}></button>
    </div>
  );
};

export default AlertMessage;
